import { ALL_CATEGORIES } from "../components/deals/dealList/constants";

/**
 * Serialize / parse `category` query param: comma-separated tokens (no commas in token values).
 * Empty string means all categories (omit param in API).
 */

export const allDealCategoryTokenValues = () =>
  ALL_CATEGORIES.map((c) => c.value).filter(Boolean);

export const parseDealCategoryParam = (raw) => {
  if (raw == null) return [];
  if (Array.isArray(raw)) {
    return raw
      .flatMap((c) => String(c).split(","))
      .map((s) => s.trim())
      .filter(Boolean);
  }
  const s = String(raw).trim();
  if (!s) return [];
  return s.split(",").map((x) => x.trim()).filter(Boolean);
};

export const serializeDealCategories = (values) => {
  if (!Array.isArray(values) || values.length === 0) return "";
  const seen = new Set();
  const out = [];
  for (const v of values) {
    const t = typeof v === "string" ? v.trim() : "";
    if (!t || seen.has(t)) continue;
    seen.add(t);
    out.push(t);
  }
  return out.join(",");
};

/** True when filters should behave as all categories (empty or every token selected). */
export const isShowingAllDealCategories = (raw) => {
  const selected = parseDealCategoryParam(raw);
  if (selected.length === 0) return true;
  const all = allDealCategoryTokenValues();
  if (selected.length !== all.length) return false;
  const set = new Set(selected);
  return all.every((v) => set.has(v));
};
